


































import { Component, Vue, Prop } from "vue-property-decorator";
import { CatatanHarianBblListItem } from "@/types/catatan_harian_bbl";

@Component
export default class BblDateNavigator extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly catatanList!: CatatanHarianBblListItem[];
  @Prop({ type: String, default: "" }) readonly selectedDate!: string;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  get selectedIndex(): number {
    return this.catatanList.findIndex((c) => c.tanggal === this.selectedDate);
  }

  chipColor(item: CatatanHarianBblListItem): string {
    if (item.alert_count > 0) return "orange";
    return "grey lighten-1";
  }

  formatDate(tanggal: string): string {
    if (!tanggal) return "";
    const parts = tanggal.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}`;
    }
    return tanggal;
  }

  onSelect(tanggal: string): void {
    this.$emit("select-date", tanggal);
  }
}
